export function localGreeting(hour: number): 'Good morning' | 'Good afternoon' | 'Good evening' {
  if (!Number.isInteger(hour) || hour < 0 || hour > 23) return 'Good morning'
  if (hour < 12) return 'Good morning'
  if (hour < 18) return 'Good afternoon'
  return 'Good evening'
}
